import * as z from "zod/v4";
import { OperatorSchema } from "./operator.js";
const PropertyFilterSchema_ = z.object({
    prop: z.string(),
    operator: OperatorSchema,
    value: z.array(z.string()),
});
export const PropertyFilterSchema = PropertyFilterSchema_;
//# sourceMappingURL=property-filter.js.map